<template>
  <div class="auditoria-login">
    <div class="login-container">
      <div class="login-card">
        <div class="login-header">
          <div class="logo">
            <img src="@/assets/images/logo.png" alt="Logo" />
          </div>
          <h1 class="login-title">Portal de Auditoria</h1>
          <p class="login-subtitle">Acesso restrito para consulta e exportação</p>
        </div>

        <div class="login-body">
          <form @submit.prevent="login" class="login-form">
            <div class="form-group">
              <label class="form-label">
                <i class="fas fa-envelope"></i>
                E-mail
              </label>
              <input
                v-model="form.email"
                type="email"
                class="form-control"
                placeholder="Digite seu e-mail"
                required
                :disabled="loading"
              />
            </div>

            <div class="form-group">
              <label class="form-label">
                <i class="fas fa-lock"></i>
                Senha
              </label>
              <div class="password-input">
                <input
                  v-model="form.senha"
                  :type="showPassword ? 'text' : 'password'"
                  class="form-control"
                  placeholder="Digite sua senha"
                  required
                  :disabled="loading"
                />
                <button
                  type="button"
                  class="password-toggle"
                  @click="togglePassword"
                  :disabled="loading"
                >
                  <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
              </div>
            </div>

            <div class="form-actions">
              <button type="submit" class="btn-login" :disabled="!isFormValid || loading">
                <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                <i v-else class="fas fa-sign-in-alt"></i>
                {{ loading ? 'Entrando...' : 'Entrar' }}
              </button>
            </div>

            <div class="login-footer">
              <button
                type="button"
                class="btn-recover"
                @click="recuperarSenha"
                :disabled="loading"
              >
                <i class="fas fa-key"></i>
                Esqueci minha senha
              </button>
            </div>
          </form>
        </div>

        <div class="login-footer-info">
          <p class="version-info">
            <i class="fas fa-shield-alt"></i>
            Auditoria - Somente leitura
          </p>
        </div>
      </div>
    </div>

    <!-- Modal de Recuperação de Senha -->
    <div v-if="showRecoverModal" class="modal-overlay" @click="closeRecoverModal">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h4 class="modal-title">
            <i class="fas fa-key"></i>
            Recuperar Senha
          </h4>
          <button @click="closeRecoverModal" class="modal-close">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <p class="modal-text">
            Digite seu e-mail para receber uma nova senha temporária.
          </p>
          <div class="form-group">
            <input
              v-model="recoverEmail"
              type="email"
              class="form-control"
              placeholder="Digite seu e-mail"
              required
            />
          </div>
        </div>
        <div class="modal-footer">
          <button @click="closeRecoverModal" class="btn btn-secondary">
            Cancelar
          </button>
          <button @click="sendRecoverEmail" class="btn btn-primary" :disabled="!recoverEmail || recoverLoading">
            <i v-if="recoverLoading" class="fas fa-spinner fa-spin"></i>
            <i v-else class="fas fa-paper-plane"></i>
            {{ recoverLoading ? 'Enviando...' : 'Enviar' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'AuditoriaLogin',
  data() {
    return {
      form: {
        email: '',
        senha: ''
      },
      showPassword: false,
      loading: false,
      showRecoverModal: false,
      recoverEmail: '',
      recoverLoading: false
    }
  },
  computed: {
    isFormValid() {
      return this.form.email && this.form.senha
    }
  },
  mounted() {
    const token = localStorage.getItem('auditor-token')
    if (token) {
      this.$router.push('/auditoria/dashboard')
    }
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword
    },
    async login() {
      if (!this.isFormValid) return
      this.loading = true
      try {
        const response = await axios.post('/ps/auditoria/login', this.form)

        if (response.data?.token) {
          localStorage.setItem('auditor-token', response.data.token)
          if (response.data.user) {
            localStorage.setItem('auditor-user', JSON.stringify(response.data.user))
          }

          axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`
          this.$sweet.showSuccess('Login realizado com sucesso!')
          setTimeout(() => this.$router.push('/auditoria/dashboard'), 500)
        } else {
          this.$sweet.showError('Credenciais inválidas!')
        }
      } catch (error) {
        console.error('Erro no login auditoria:', error)
        const msg = error.response?.data?.error || 'Erro ao realizar login. Tente novamente.'
        this.$sweet.showError(msg)
      } finally {
        this.loading = false
      }
    }
    ,
    recuperarSenha() {
      this.showRecoverModal = true
      this.recoverEmail = this.form.email
    },
    closeRecoverModal() {
      this.showRecoverModal = false
      this.recoverEmail = ''
      this.recoverLoading = false
    },
    async sendRecoverEmail() {
      if (!this.recoverEmail) return
      this.recoverLoading = true
      try {
        await axios.post('/ps/auditoria/recuperar-senha', { email: this.recoverEmail })
        this.$sweet.showSuccess('Nova senha enviada para seu e-mail.')
        this.closeRecoverModal()
      } catch (error) {
        console.error('Erro ao recuperar senha auditoria:', error)
        const msg = error.response?.data?.error || 'Erro ao enviar e-mail de recuperação de senha'
        this.$sweet.showError(msg)
      } finally {
        this.recoverLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.auditoria-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  padding: 20px;
}

.login-container {
  width: 100%;
  max-width: 520px;
}

.login-card {
  background: rgba(255, 255, 255, 0.96);
  border-radius: 16px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.4);
}

.login-header {
  padding: 28px 28px 14px;
  text-align: center;

  .logo img {
    height: 46px;
    margin-bottom: 12px;
  }

  .login-title {
    margin: 0;
    font-size: 26px;
    font-weight: 700;
    color: #1f2937;
  }

  .login-subtitle {
    margin: 8px 0 0 0;
    color: #6b7280;
    font-size: 14px;
  }
}

.login-body {
  padding: 18px 28px 28px;
}

.form-group {
  margin-bottom: 16px;
}

.form-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.password-input {
  position: relative;

  .password-toggle {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    border: none;
    background: transparent;
    color: #6b7280;
    cursor: pointer;
  }
}

.btn-login {
  width: 100%;
  border: none;
  padding: 12px 16px;
  border-radius: 10px;
  background: #4f46e5;
  color: white;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: background 0.2s ease;

  &:hover:not(:disabled) {
    background: #4338ca;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.login-footer-info {
  padding: 14px 28px 22px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  text-align: center;

  .version-info {
    margin: 0;
    color: #4b5563;
    font-size: 13px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }
}

.login-footer {
  margin-top: 14px;
  text-align: center;
}

.btn-recover {
  background: transparent;
  border: none;
  color: #4f46e5;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 8px;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(79, 70, 229, 0.08);
  }
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.modal-content {
  background: white;
  border-radius: 14px;
  width: 100%;
  max-width: 520px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.modal-header {
  padding: 16px 18px;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .modal-title {
    margin: 0;
    font-size: 18px;
    font-weight: 800;
    color: #2c3e50;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .modal-close {
    background: none;
    border: none;
    color: #6c757d;
    cursor: pointer;
    width: 34px;
    height: 34px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s ease;

    &:hover {
      background: #f8f9fa;
    }
  }
}

.modal-body {
  padding: 18px;
  .modal-text {
    margin: 0 0 12px 0;
    color: #6c757d;
  }
}

.modal-footer {
  padding: 16px 18px;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>

